import React from 'react';
import { MobileAI } from './MobileAI';
import { DesktopAI } from './DesktopAI';
import { AIProps } from './types';

export default function AI(props: AIProps) {
  const {
    deviceType, type,
    ...otherProps
  } = props;

  if (deviceType === 'mobile') {
    return <MobileAI type={type} deviceType={deviceType} {...otherProps} />;
  }

  return <DesktopAI type={type} deviceType={deviceType} toggleOpen={() => {}} {...otherProps} />;
}
